export const makeAction = (type, payload, opts) => {
  return {type, payload, opts}
}



// WEBPACK FOOTER //
// ./src/app/util/reduxhelper.js